import React from 'react';
import { Modal } from 'react-bootstrap';
import { Fire, Snow } from 'react-bootstrap-icons';
import './UserInfoModal.css'
import teamIcons from './../../utils/teamIcons';

function UserInfoModal({
    fullUserInfo,
    showModal,
    setShowModal,
    showSpinnerInModal,
    setShowSpinnerInModal,
    setFullUserInfo
}) {

    const ready = !showSpinnerInModal && fullUserInfo;

    return (
        <>
            <Modal key='user-modal' className='user-info-modal' show={showModal} onHide={()=>{setShowModal(false); setShowSpinnerInModal(false); setFullUserInfo(undefined)}}>
                    <Modal.Header key='modal-header' closeButton>
                        <Modal.Title key='modal-title' className='user-info-title'>
                            {
                                ready
                                    ? <>
                                        <span className='user-info-avatar'>{fullUserInfo['fullname'] ? fullUserInfo['fullname'].charAt(0).toUpperCase() : '?'}</span>
                                        <span className='user-info-title-text'>
                                            <span className='user-info-fullname'>{fullUserInfo['fullname']}</span>
                                            <span className='user-info-username'>@{fullUserInfo['username']}</span>
                                        </span>
                                    </>
                                    : ''
                            }
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body scrollable={true}>
                        {
                            ready
                                ?
                                    <>
                                        <div className='user-info-stats-row'>
                                            <div className='user-info-stat'>
                                                <span className='user-info-stat-value'>{fullUserInfo['start_streak']}</span>
                                                <span className='user-info-stat-label'>Start Streak</span>
                                            </div>
                                            <div className='user-info-stat-divider' />
                                            <div className='user-info-stat'>
                                                <span className='user-info-stat-value'>{fullUserInfo['total_correct']}</span>
                                                <span className='user-info-stat-label'>Total Correct</span>
                                            </div>
                                            <div className='user-info-stat-divider' />
                                            <div className='user-info-stat'>
                                                {
                                                    fullUserInfo['is_start_streak_alive']
                                                        ? <Fire className='user-info-alive-icon alive' />
                                                        : <Snow className='user-info-alive-icon eliminated' />
                                                }
                                                <span className='user-info-stat-label'>
                                                    {fullUserInfo['is_start_streak_alive'] ? 'Alive' : 'Eliminated'}
                                                </span>
                                            </div>
                                        </div>

                                        <div className='user-info-picks-heading section-heading'>Pick History</div>
                                        <div className='user-info-picks-grid'>
                                            {
                                               fullUserInfo['user_picked_teams'].map((val, i) => {
                                                    const currTeam = Object.keys(val)[0];
                                                    const result = Object.values(val)[0];

                                                    // Same fix as PastPicksCard.js -- the Commanders SVG's default
                                                    // viewBox crops the logo oddly at this icon size.
                                                    if(currTeam === 'Commanders') {
                                                        const mySVG = document.getElementById('Commanders');
                                                        if(mySVG) mySVG.setAttribute('viewBox', '-100 -150 675 400');
                                                    }

                                                    if(currTeam.includes('Team')) {
                                                        return (
                                                            <div key={i+'-pick'} className='user-info-pick-chip'>
                                                                <span className='user-info-pick-week'>W{i+1}</span>
                                                                <span className='user-info-pick-none'>&ndash;</span>
                                                            </div>
                                                        );
                                                    }

                                                    const CurrIcon = teamIcons[currTeam];
                                                    const resultClass = result === '' ? '' : (result ? 'correct-pick' : 'incorrect-pick');
                                                    return (
                                                        <div key={i+'-pick'} className={'user-info-pick-chip ' + resultClass}>
                                                            <span className='user-info-pick-week'>W{i+1}</span>
                                                            <CurrIcon/>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </>
                                :
                                    <div key='spin-div' className='user-info-skeleton'>
                                        <div className='skeleton user-info-skeleton-row' style={{width: '70%'}} />
                                        <div className='skeleton user-info-skeleton-row' style={{width: '50%'}} />
                                        <div className='skeleton user-info-skeleton-row' style={{width: '55%'}} />
                                        <div className='skeleton user-info-skeleton-row' style={{width: '40%'}} />
                                        <div className='skeleton user-info-skeleton-grid' />
                                    </div>

                        }
                    </Modal.Body>
            </Modal>
        </>
    );

}

export default UserInfoModal;
